<div class="confirmContainer">
    <div class="confirmBox">
        <div class="d-flex justify-content-between">
            <span class="table-title">High Alert</span>
            <button (click)="no()"  class="sortBtn"><i class="fa-solid fa-xmark crossicon"></i></button>
          </div>
       
          <div class="KBBody table-responsive ">

            <!-- <table class="table table-hover  mb-0"> -->
                
              
    
                <!-- <tbody class="scrollable-body"> -->
                 
                   
                   
                  <table class="table table-hover  m-0 p-0">
                    <thead >
                      <tr>
                        <th scope="col" class="text-left">Category</th>
                        <th scope="col">Count</th>
                        
                            
                      </tr>
                    </thead>
                    <tbody>
                    <tr >
                      <td class="text-left">Security</td>
                      <td>{{seHigh}}</td>
                      
                    </tr>
                    <tr >
                        <td class="text-left">Governance</td>
                        <td>{{govHigh}}</td>
                        
                      </tr>
                      <tr >
                        <td class="text-left">Daily Spend</td>
                        <td>{{dsHigh}}</td>
                        
                      </tr>
                      <tr >
                        <td class="text-left">Daily Cost</td>
                        <td>{{dcHigh}}</td>
                        
                      </tr>
                      <tr >
                        <td class="text-left"> <b>Total</b></td>
                        <td><b>{{dcHigh+dsHigh+govHigh+seHigh}}</b></td>
                        
                      </tr>
                      <!-- <tr >
                        <td>Others</td>
                        <td>5</td>
                        
                      </tr> -->
                    <!-- <tr >
                      <td>{{j+1}}</td>
                      <td>{{mon.cost[1]['key']}}</td>
                      <td>{{mon.cost[1]['value']}}</td>
                    </tr> -->
                  </tbody>
                </table>
             
                 
                  <!-- <ng-container *ngFor="let i of instancesTypes;">
                    <tr *ngFor="let value of i[key]>
                    <td>{{key}}</td>
                   
                  </tr>
                  </ng-container>            -->
                <!-- </tbody>  -->
            <!-- </table> -->
            
              <!-- <div class="btnHold">
                <div class="bhold">
                  <button class="btn m-2" [disabled]="sg_currentPage === 1" (click)="sg_onPrev()">Previous</button>
                  <button class="btn m-2" [disabled]="getDisplaySGData().length < sg_itemsPerPage"  
                  [disabled]="SGList.length < 5" (click)="sg_onNext()">Next</button>
                </div>
              </div> -->
    
    
            <!-- <div class="KBActions">
              <button class="btn btn-light" (click)="no()">Cancel</button>
            </div> -->
          
        </div>
          
</div>



